/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionGeneratedDocumentExternalEhrDocument
 */
export interface PalAuthSubmissionGeneratedDocumentExternalEhrDocument {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    external_ehr_document_id?: string;
    /**
     * 
     */
    relation_type?: PalAuthSubmissionGeneratedDocumentExternalEhrDocumentRelationTypeEnum;
    /**
     * 
     */
    relation_id?: string;
    /**
     * 
     */
    created_at?: string;
}


/**
 * @export
 */
export const PalAuthSubmissionGeneratedDocumentExternalEhrDocumentRelationTypeEnum = {
    ScreenerDocument: 'screener_document',
    ScreenerAdditionalDocument: 'screener_additional_document',
    ScreenerGeneratedDocument: 'screener_generated_document',
} as const;
export type PalAuthSubmissionGeneratedDocumentExternalEhrDocumentRelationTypeEnum = typeof PalAuthSubmissionGeneratedDocumentExternalEhrDocumentRelationTypeEnum[keyof typeof PalAuthSubmissionGeneratedDocumentExternalEhrDocumentRelationTypeEnum];


/**
 * Check if a given object implements the PalAuthSubmissionGeneratedDocumentExternalEhrDocument interface.
 */
export function instanceOfPalAuthSubmissionGeneratedDocumentExternalEhrDocument(value: object): value is PalAuthSubmissionGeneratedDocumentExternalEhrDocument {
    return true;
}

export function PalAuthSubmissionGeneratedDocumentExternalEhrDocumentFromJSON(json: any): PalAuthSubmissionGeneratedDocumentExternalEhrDocument {
    return PalAuthSubmissionGeneratedDocumentExternalEhrDocumentFromJSONTyped(json, false);
}

export function PalAuthSubmissionGeneratedDocumentExternalEhrDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionGeneratedDocumentExternalEhrDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'type': json['type'] == null ? undefined : json['type'],
        'external_ehr_document_id': json['external_ehr_document_id'] == null ? undefined : json['external_ehr_document_id'],
        'relation_type': json['relation_type'] == null ? undefined : json['relation_type'],
        'relation_id': json['relation_id'] == null ? undefined : json['relation_id'],
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
    };
}

export function PalAuthSubmissionGeneratedDocumentExternalEhrDocumentToJSON(json: any): PalAuthSubmissionGeneratedDocumentExternalEhrDocument {
    return PalAuthSubmissionGeneratedDocumentExternalEhrDocumentToJSONTyped(json, false);
}

export function PalAuthSubmissionGeneratedDocumentExternalEhrDocumentToJSONTyped(value?: PalAuthSubmissionGeneratedDocumentExternalEhrDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'type': value['type'],
        'external_ehr_document_id': value['external_ehr_document_id'],
        'relation_type': value['relation_type'],
        'relation_id': value['relation_id'],
        'created_at': value['created_at'],
    };
}

